export const SAVE_ANSWER = 'SAVE_ANSWER';
export const INITIAL_VALUES = 'INITIAL_VALUES';
